import React from 'react'
import { IoArrowBackCircleOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom';

export default function BackButton() {
    const navigate = useNavigate();

    return (
        <>
            <IoArrowBackCircleOutline
                // width={22}
                onClick={() => navigate(-1)}
                className="mt-1.5 mr-2 cursor-pointer text-[25px]"
            />
        </>
    )
}
